import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, unref as _unref, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-25eed2b5"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "content sub" }
const _hoisted_2 = { class: "td" }
const _hoisted_3 = {
  key: 2,
  class: "td"
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"flex-grow":"1","border-bottom":"2px dotted #1da57a"} }, null, -1))

import ScDrag from '@/components/common/drag/ScDrag';
import { ref } from 'vue';
import ScBtn from '@/components/common/widget/ScBtn.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'DeviceNode',
  props: {
    level: {},
    data: {},
    source: {},
    remove: { type: Function }
  },
  setup(__props: any) {

const props = __props;
const line = ref();

return (_ctx: any,_cache: any) => {
  const _component_sc_icon = _resolveComponent("sc-icon")!
  const _component_a_tag = _resolveComponent("a-tag")!

  return (_openBlock(), _createBlock(_unref(ScDrag), {
    format: "node",
    data: JSON.stringify({ data: _ctx.data, source: _ctx.source }),
    img: { el: line.value }
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", {
        class: "line",
        ref_key: "line",
        ref: line,
        style: _normalizeStyle(`margin-left: ${_ctx.level * 22}px`)
      }, [
        _createElementVNode("div", _hoisted_1, [
          _createVNode(_component_sc_icon, { type: "MobileTwoTone" }),
          _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.data.name), 1),
          (_ctx.data.group)
            ? (_openBlock(), _createBlock(_component_a_tag, {
                key: 0,
                color: "blue"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.data.group?.name), 1)
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (_ctx.data.tags)
            ? (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_ctx.data.tags.list, (item, k) => {
                return (_openBlock(), _createBlock(_component_a_tag, {
                  color: "green",
                  key: k
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(item.name), 1)
                  ]),
                  _: 2
                }, 1024))
              }), 128))
            : _createCommentVNode("", true),
          (_ctx.data.remark)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(_ctx.data.remark), 1))
            : _createCommentVNode("", true),
          (_ctx.level > 0)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                _hoisted_4,
                (_ctx.remove)
                  ? (_openBlock(), _createBlock(ScBtn, {
                      key: 0,
                      type: "link",
                      handler: _ctx.remove,
                      text: "移除"
                    }, null, 8, ["handler"]))
                  : _createCommentVNode("", true)
              ], 64))
            : _createCommentVNode("", true)
        ])
      ], 4)
    ]),
    _: 1
  }, 8, ["data", "img"]))
}
}

})